import { render, staticRenderFns } from "./crossclassification.vue?vue&type=template&id=2e8688c0&"
import script from "./crossclassification.vue?vue&type=script&lang=js&"
export * from "./crossclassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports